(() => {
  if (window.kleonePdpReady) return;
  window.kleonePdpReady = true;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-kp-product-link]');
    if (!link) return;
    const hero = document.querySelector('[data-maison-pdp-hero]');
    if (!hero) return;
    event.preventDefault();
    hero.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
    const target = hero.querySelector('[data-maison-variant-select], button[type="submit"]');
    target?.focus({ preventScroll: true });
  });
  class KleoneStickyCart extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const opts = { signal: this.abort.signal };
      this.hero = document.querySelector('[data-maison-pdp-hero]');
      this.form = this.hero?.querySelector('form[action*="/cart/add"]');
      this.originalButton = this.form?.querySelector('button[type="submit"]');
      if (!this.form || !this.originalButton) return;
      this.button = this.querySelector('[data-kp-add]');
      this.status = this.querySelector('[data-kp-status]');
      this.variants = JSON.parse(this.querySelector('[data-kp-variants]').textContent).variants;
      this.sync = () => {
        const id = new FormData(this.form).get('id');
        const variant = this.variants.find(v => String(v.id) === String(id));
        const price = this.querySelector('[data-kp-price]');
        const bundlePrice = this.hero.querySelector('.kaching-bundles__bar--selected .kaching-bundles__bar-price')?.textContent.trim();
        if (price && variant) price.textContent = bundlePrice || variant.price;
        if (!this.busy) {
          this.button.disabled = !variant?.available || this.originalButton.disabled;
          this.button.textContent = this.button.disabled ? this.dataset.soldOutLabel : this.dataset.buttonLabel;
        }
      };
      this.sync();
      this.hero.addEventListener('change', this.sync, opts);
      this.hero.addEventListener('input', this.sync, opts);
      this.mutation = new MutationObserver(this.sync);
      this.mutation.observe(this.hero, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['value', 'disabled', 'class'] });
      this.observer = new IntersectionObserver(([entry]) => {
        this.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
      }, { threshold: 0 });
      this.observer.observe(this.originalButton);
      this.button.addEventListener('click', () => {
        if (this.busy || this.originalButton.disabled || !this.form.reportValidity()) return;
        this.busy = true;
        this.button.disabled = true;
        this.button.textContent = this.dataset.loadingLabel;
        this.status.textContent = '';
        this.originalButton.click();
        this.timeout = setTimeout(() => {
          this.busy = false;
          this.status.textContent = 'Please check your cart before trying again.';
          this.sync();
        }, 15000);
      }, opts);
      document.addEventListener('cart:update', (event) => {
        if (!this.busy) return;
        clearTimeout(this.timeout);
        this.busy = false;
        if (!event.detail?.data?.didError) this.status.textContent = this.dataset.addedLabel;
        this.sync();
      }, opts);
      document.addEventListener('cart:error', (event) => {
        if (!this.busy) return;
        clearTimeout(this.timeout);
        this.busy = false;
        this.status.textContent = event.detail?.description || event.detail?.message || 'Unable to add to cart. Please try again.';
        this.sync();
      }, opts);
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.mutation?.disconnect();
      clearTimeout(this.timeout);
    }
  }
  customElements.define('kleone-sticky-cart', KleoneStickyCart);
})();
